import { CommercialItem } from '../commercial-item.model';
import { QuotationLine } from './quotation-line.model';

export class InvoiceableItemRequest {
    testQuotationLine: QuotationLine[] = [];
    packageQuotationLine: QuotationLine[] = [];
    customerPackage: QuotationLine[] = [];

    // Used only for sales catalog scope
    test: CommercialItem[] = [];
    package: CommercialItem[] = [];

    constructor(
        testQuotationLine?: QuotationLine[],
        packageQuotationLine?: QuotationLine[],
        customerPackage?: QuotationLine[],
        test?: CommercialItem[],
        quoPackage?: CommercialItem[] // Renamed as package is a reserved word
    ) {
        this.testQuotationLine = testQuotationLine;
        this.packageQuotationLine = packageQuotationLine;
        this.customerPackage = customerPackage;
        this.test = test;
        this.package = quoPackage;
    }
}
